// extracted by mini-css-extract-plugin
module.exports = {"root":"Toggle_root__2g4x4","button":"Toggle_button__kEoh7","selected":"Toggle_selected__1N_p-"};